import SkeletonRow from "@/components/SkeletonRow"
import { Button } from "@/components/ui/button"
import useScreen from "@/hooks/useScreen"
import useTimePeriode from "@/hooks/useTimePeriode"
import { SysProgramStudi } from "@/types"
import { ChevronRight } from "lucide-react"
import { useEffect, useState } from "react"
import { GoDot } from "react-icons/go"

export default function ListProdi({
  dataProdi,
  isPending,
}: {
  dataProdi: {
    list_prodi_vokasi: SysProgramStudi[]
    list_prodi_sarjana: SysProgramStudi[]
    list_prodi: SysProgramStudi[]
  }
  isPending: boolean
}) {
  const { dataPeriode } = useTimePeriode()
  const { isMobile } = useScreen()
  const [showProgram, setShowProgram] = useState("")

  useEffect(() => {
    if (isMobile) setShowProgram("")
    else setShowProgram("SARJANA")
  }, [isMobile])

  return (
    <div className="flex flex-col gap-y-3">
      {/* <div className="py-2 px-3 border rounded-xl">
        <div className="flex items-center justify-between gap-3">
          <div>
            <h1 className="font-semibold">Program Vokasi</h1>
            <p className="text-sm text-muted-foreground">
              Diploma Tiga dan Diploma Empat/Sarjana Terapan
            </p>
          </div>
          <div>
            <Button
              variant={"outline"}
              size={"icon"}
              onClick={() => {
                if (showProgram === "VOKASI") setShowProgram("");
                else setShowProgram("VOKASI");
              }}
            >
              <ChevronRight
                className={`${
                  showProgram === "VOKASI" ? "rotate-90" : ""
                } duration-300`}
              />
            </Button>
          </div>
        </div>
        {showProgram === "VOKASI" && (
          <div className="mt-3 grid lg:grid-cols-2 grid-cols-1 gap-3">
            {dataProdi && dataProdi?.list_prodi_vokasi?.length > 0
              ? dataProdi?.list_prodi_vokasi?.map(
                  (sysProdi: SysProgramStudi) => {
                    return (
                      <div
                        key={sysProdi.uk_id}
                        className="flex gap-3 items-center"
                      >
                        <GoDot />
                        <span>{sysProdi.unitkerja?.nama}</span>
                      </div>
                    );
                  }
                )
              : ""}
          </div>
        )}
      </div> */}
      <div className="py-2 px-3 border rounded-xl">
        <div className="flex items-center justify-between gap-3">
          <div>
            <h1 className="font-semibold">
              {dataPeriode?.jalur_jenis?.nama_jalur_jenis}
            </h1>
            <p className="text-sm text-muted-foreground">
              Berikut adalah daftar program studi jalur{" "}
              {dataPeriode?.jalur_jenis?.nama_jalur_jenis}
            </p>
          </div>
          <div>
            <Button
              variant={"outline"}
              size={"icon"}
              onClick={() => {
                if (showProgram === "SARJANA") setShowProgram("")
                else setShowProgram("SARJANA")
              }}
            >
              <ChevronRight
                className={`${
                  showProgram === "SARJANA" ? "rotate-90" : ""
                } duration-300`}
              />
            </Button>
          </div>
        </div>
        {showProgram === "SARJANA" &&
          (isPending ? (
            <div className="mt-3 flex flex-col gap-y-3">
              {Array(10)
                .fill(null)
                .map((_, index) => {
                  return <SkeletonRow key={index} />
                })}
            </div>
          ) : (
            <div className="mt-3 grid lg:grid-cols-2 grid-cols-1 gap-3">
              {dataProdi && dataProdi?.list_prodi_sarjana?.length > 0
                ? dataProdi?.list_prodi_sarjana?.map(
                    (sysProdi: SysProgramStudi) => {
                      return (
                        <div
                          key={sysProdi.uk_id}
                          className="flex gap-3 items-center"
                        >
                          <GoDot />
                          <span>{sysProdi.unitkerja?.nama}</span>
                        </div>
                      )
                    }
                  )
                : ""}
            </div>
          ))}
      </div>
    </div>
  )
}
